import React from "react";

import {EllipsisOutlined} from "@ant-design/icons";
import {Button, Dropdown} from "antd";

export function ActionsMenu({actions}) {
	return (
		<Dropdown
			overlay={actions}
			trigger={["click"]}
			getPopupContainer={() => document.body}>
			<Button style={{marginTop: 5}} onClick={e => e.stopPropagation()}>
				<EllipsisOutlined />
			</Button>
		</Dropdown>
	);
}
